import * as React from 'react'

import Wait from "../wait";
import CollectService from "../../service/v1/collect";
import AddDodosoPane from "../add/add_dodoso_pane";
import {generateUUID} from "../../ug/uuid";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PopBig from "../popbig";
import CreateService from "../../service/create";
import baseUrl from "../../service/baseURL";
import DownloadProgressModal from "../download_progress_modal";

// Modern styling constants
const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
const primaryColor = '#395d9a';
const secondaryColor = '#2bbbad';
const accentColor = '#fbc02d';
const successColor = '#8bc34a';
const dangerColor = '#f44336';
const lightGray = '#f8f9fa';
const borderColor = '#e9ecef';

const containerStyle = {
    fontFamily,
    fontSize: '16px',
    height: '100%',
    background: lightGray,
    overflow: 'hidden'
};

const headerStyle = {
    background: 'linear-gradient(135deg, #395d9a 0%, #2bbbad 100%)',
    color: 'white',
    padding: '16px 24px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px'
};

const headerTitleStyle = {
    fontSize: '20px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
};

const filterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap'
};

const selectStyle = {
    padding: '8px 12px',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: '6px',
    background: 'rgba(255,255,255,0.1)',
    color: 'white',
    fontSize: '14px',
    minWidth: '150px',
    backdropFilter: 'blur(10px)'
};

const buttonStyle = {
    padding: '8px 16px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    textDecoration: 'none'
};

const primaryButtonStyle = {
    ...buttonStyle,
    background: 'rgba(255,255,255,0.2)',
    color: 'white',
    border: '1px solid rgba(255,255,255,0.3)'
};

const successButtonStyle = {
    ...buttonStyle,
    background: successColor,
    color: 'white'
};

const mainContainerStyle = {
    display: 'flex',
    height: 'calc(100vh - 80px)',
    overflow: 'hidden'
};

const sidebarStyle = {
    width: '300px',
    background: 'white',
    borderRight: `1px solid ${borderColor}`,
    overflowY: 'auto',
    boxShadow: '2px 0 8px rgba(0,0,0,0.05)'
};

const contentStyle = {
    flex: 1,
    background: 'white',
    overflowY: 'auto',
    padding: '24px'
};

const menuItemStyle = {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: `1px solid ${borderColor}`,
    transition: 'all 0.2s ease',
    fontSize: '14px',
    fontWeight: 500
};

const activeMenuItemStyle = {
    ...menuItemStyle,
    background: `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    color: 'white',
    borderLeft: `4px solid ${accentColor}`
};

const subMenuItemStyle = {
    padding: '8px 16px 8px 32px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#666',
    transition: 'all 0.2s ease',
    borderLeft: `2px solid transparent`
};

const activeSubMenuItemStyle = {
    ...subMenuItemStyle,
    color: primaryColor,
    background: `${primaryColor}10`,
    borderLeft: `2px solid ${primaryColor}`,
    fontWeight: 500
};

const cardStyle = {
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    overflow: 'hidden',
    border: `1px solid ${borderColor}`
};

const cardHeaderStyle = {
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    color: 'white',
    padding: '16px 20px',
    fontSize: '16px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
};

const tableContainerStyle = {
    overflowX: 'auto',
    borderRadius: '8px',
    border: `1px solid ${borderColor}`
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px'
};

const tableHeaderStyle = {
    background: lightGray,
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: 600,
    color: primaryColor,
    borderBottom: `2px solid ${borderColor}`
};

const tableCellStyle = {
    padding: '12px 16px',
    borderBottom: `1px solid ${borderColor}`,
    verticalAlign: 'top'
};

const actionBarStyle = {
    padding: '16px 20px',
    background: lightGray,
    borderTop: `1px solid ${borderColor}`,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap'
};

const chartContainerStyle = {
    padding: '20px',
    background: 'white',
    borderRadius: '8px',
    marginBottom: '16px'
};

const viewToggleStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '16px'
};

const viewToggleButtonStyle = {
    padding: '8px 12px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
    background: lightGray,
    color: '#666',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
};

const activeViewToggleButtonStyle = {
    ...viewToggleButtonStyle,
    background: primaryColor,
    color: 'white'
};

export default class QuestionnairePane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            current_menu: 0,
            questionnaires: [],
            forms: [],
            analysis: [],
            questions: [],
            village_id: 0,
            answers: [],
            dataview: [
                {name: 'Bar Graph', key: 'bar', icon: 'fa-bar-chart'},
                {name: 'Pie Chart', key: 'pie', icon: 'fa-pie-chart'},
                {name: 'Table View', key: 'table', icon: 'fa-table'}
            ],
            regions: [],
            districts: [],
            wards: [],
            villages: [],
            hamlets: [],
            parent_id: 0,
            parent_hamlet: 0,
            expandedMenus: {}
        }
        this.loadData = this.loadData.bind(this)
        this.loadQuestionnaires = this.loadQuestionnaires.bind(this)
        this.loadQuestionnairesForms = this.loadQuestionnairesForms.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.changeViewAt = this.changeViewAt.bind(this)
        this.popAddNew = this.popAddNew.bind(this)
        this.toggleMenu = this.toggleMenu.bind(this)
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    componentDidMount() {
        this.loadLocalities()
        this.loadQuestionnaires()
    }

    popAddNew() {
        let villagename = ''
        PopBig.show('Ongeza Taarifa - ' + villagename,
            <AddDodosoPane project={this.props.project}
                           loadData={() => this.loadQuestionnaires()}
                           uuid={generateUUID()} 
                           village={this.state.parent_hamlet} 
                           villagename={villagename}
                           questionnaires={this.state.questionnaires}
                           task_id={this.props.taskId}
                           key={new Date().getMilliseconds()}/>)
    }

    loadQuestionnaires() {
        try {
            Wait.show('Fetching Questions')
            console.log("MOMO : " + this.props.project.project_type_info.name)
            CollectService.fetchQuestions(this.props.project.id, this.props.flag === 'analyse' ? 0 : 1, 'dodoso',
                this.props.flag === 'analyse' ? 1 : 0).then(r => {
                try {
                    Wait.dismiss()
                    let result = r.data.results
                    let loc = r.data.localities

                    if (loc.regions.length === 1) {
                        this.setState({
                            parent_id: loc.regions[0].id
                        })
                    }
                    this.setState({
                        questionnaires: result,
                        regions: loc.regions,
                        districts: loc.districts,
                        wards: loc.wards,
                        villages: loc.villages,
                        hamlets: loc.hamlets,
                    })
                } catch (e) {
                    Wait.dismiss()
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    loadQuestionnairesForms(form_id, i = 0, j = 0) {
        try {
            console.log(this.props.flag)
            if (this.props.flag === 'analyse') {
                Wait.show('Analysing.....')
                CollectService.fetchQuestionsFormsAnalyse(this.props.project.id, form_id).then(r => {
                    try {
                        Wait.dismiss()
                        this.setState({
                            analysis: r.data.results,
                            current_menu: i,
                            current_menu_j: j
                        })
                    } catch (e) {
                        console.log(e)
                    }
                })
            } else {
                Wait.show('Fetching Forms....')
                CollectService.fetchQuestionsForms(this.props.project.id, form_id, 1,
                    this.props.project.project_type_info.name.toString().toLowerCase().includes("monitoring")
                        ? 1 : 0).then(r => {
                    try {
                        Wait.dismiss()
                        console.log(r.data.results)
                        this.setState({
                            forms: r.data.results,
                            current_menu: i,
                            current_menu_j: j
                        })
                    } catch (e) {
                        console.log(e)
                    }
                })
            }
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    render() {
        return (
            <div style={{fontSize: '16px', height: '100%', fontFamily: 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif', paddingTop: 0, marginTop: 0}}>
            <div className={'row'}>
                <div className={'col col-sm-12'}
                         style={{
                             padding: '16px 24px', 
                             background: 'transparent', 
                             color: '#333',
                             position: 'sticky', 
                             top: 0, 
                             zIndex: 2,
                             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                             display: 'flex',
                             alignItems: 'center',
                             justifyContent: 'space-between',
                             flexWrap: 'wrap',
                             gap: '16px'
                         }}>
                        <span style={{fontSize: '20px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <span className={'fa fa-list'}/>
                            {this.props.flag === 'analyse' ? 'Data Analysis' : 'Questionnaires'}
                    </span>

                    <div style={{overflow: 'hidden', display: 'inherit', float: 'right'}}>
                        <select style={{
                            marginRight: '8px',
                                visibility: this.state.regions.length > 1 ? 'visible' : 'hidden',
                                padding: '8px 12px',
                                border: '1px solid #e9ecef',
                                borderRadius: '6px',
                                background: 'white',
                                color: '#333',
                                fontSize: '14px'
                        }} onChange={this.handleChanges} name={'parent_id'}>
                            <option>- Choose Region -</option>
                            {this.state.regions.map((d, i) => {
                                return (<option value={d.id} key={i}>{d.name}</option>)
                            })}
                        </select>
                        <select style={{
                            marginRight: '8px',
                                visibility: this.state.districts.length > 1 ? 'visible' : 'hidden',
                                padding: '8px 12px',
                                border: '1px solid #e9ecef',
                                borderRadius: '6px',
                                background: 'white',
                                color: '#333',
                                fontSize: '14px'
                        }} onChange={this.handleChanges} name={'parent_ward'}>
                            <option value={0}>- Choose District -</option>
                            {this.state.districts.map((d, i) => {
                                if (parseInt(d.parent) === parseInt(this.state.parent_id)) {
                                    return (<option value={d.id} key={i}>{d.name}</option>)
                                }
                            })}
                        </select>

                            <button className={'btn'} onClick={this.popAddNew} style={{
                                padding: '6px 16px',
                                border: 'none',
                                borderRadius: '0px',
                                background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
                                color: 'white',
                                fontSize: '14px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                                transition: 'background 0.2s'
                            }}>
                            <span className={'fa fa-plus'}/>Add New
                        </button>
                    </div>
                </div>
            </div>

                <div className={'row'} style={{height: 'calc(100vh - 80px)'}}>
                <div className={'col col-sm-3'}
                         style={{
                             width: '250px',
                             height: '100%', 
                             borderRight: '1px solid #e9ecef', 
                             padding: 0, 
                             overflowY: "auto",
                             background: 'white'
                         }}>

                    {this.state.questionnaires.map((d, i) => {
                        return (<div key={i}>
                            <div
                                    className={i === this.state.current_menu ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}
                                    style={{
                                        padding: '8px 12px',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        borderBottom: '1px solid #e9ecef',
                                        position: 'relative',
                                        cursor: 'pointer',
                                        title: `${d.name} - Click to view forms`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}
                                    onClick={() => this.toggleMenu(i)}
                                    onMouseEnter={(e) => {
                                        const tooltip = document.createElement('div');
                                        tooltip.id = 'tooltip-' + i;
                                        tooltip.style.cssText = `
                                            position: absolute;
                                            left: 100%;
                                            top: 50%;
                                            transform: translateY(-50%);
                                            background: #333;
                                            color: white;
                                            padding: 12px 16px;
                                            border-radius: 8px;
                                            font-size: 13px;
                                            white-space: nowrap;
                                            z-index: 1000;
                                            margin-left: 15px;
                                            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                                            pointer-events: none;
                                            max-width: 300px;
                                            min-width: 200px;
                                        `;
                                        
                                        // Create detailed content for the tooltip
                                        const formCount = d.forms.length;
                                        const formNames = d.forms.map(f => f.name).join(', ');
                                        tooltip.innerHTML = `
                                            <div style="font-weight: 600; margin-bottom: 8px; color: #fff;">
                                                ${d.name}
                            </div>
                                            <div style="font-size: 12px; color: #ccc; margin-bottom: 6px;">
                                                Contains ${formCount} form${formCount > 1 ? 's' : ''}
                                            </div>
                                            <div style="font-size: 11px; color: #aaa; line-height: 1.4;">
                                                ${formNames.length > 100 ? formNames.substring(0, 100) + '...' : formNames}
                                            </div>
                                        `;
                                        
                                        e.target.appendChild(tooltip);
                                    }}
                                    onMouseLeave={(e) => {
                                        const tooltip = document.getElementById('tooltip-' + i);
                                        if (tooltip) {
                                            tooltip.remove();
                                        }
                                    }}
                                >
                                    <span>{d.name}</span>
                                    <span className={`fa ${this.state.expandedMenus[i] ? 'fa-chevron-down' : 'fa-chevron-right'}`} 
                                          style={{fontSize: '12px', color: '#666'}}/>
                                </div>
                                <div style={{
                                    width: '100%',
                                    display: this.state.expandedMenus[i] ? 'block' : 'none'
                                }}>
                                {d.forms.map((f, j) => {
                                    return (<div className={'sub-menu'} key={j}
                                                     onClick={(e) => {
                                                         e.stopPropagation();
                                                         this.loadQuestionnairesForms(f.id, i, j);
                                                     }}
                                                     style={{
                                                         padding: '4px 8px 4px 20px',
                                                         fontSize: '13px',
                                                         cursor: 'pointer',
                                                         transition: 'all 0.2s ease',
                                                         position: 'relative'
                                                     }}
                                                     title={`${f.name} - Click to load data`}
                                                     onMouseEnter={(e) => {
                                                         const tooltip = document.createElement('div');
                                                         tooltip.id = 'tooltip-' + i + '-' + j;
                                                         tooltip.style.cssText = `
                                                             position: absolute;
                                                             left: 100%;
                                                             top: 50%;
                                                             transform: translateY(-50%);
                                                             background: #333;
                                                             color: white;
                                                             padding: 12px 16px;
                                                             border-radius: 8px;
                                                             font-size: 13px;
                                                             white-space: nowrap;
                                                             z-index: 1000;
                                                             margin-left: 15px;
                                                             box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                                                             pointer-events: none;
                                                             max-width: 250px;
                                                             min-width: 180px;
                                                         `;
                                                         
                                                         // Create detailed content for the sub-menu tooltip
                                                         tooltip.innerHTML = `
                                                             <div style="font-weight: 600; margin-bottom: 6px; color: #fff;">
                                                                 ${f.name}
                                                             </div>
                                                             <div style="font-size: 12px; color: #ccc;">
                                                                 Form ID: ${f.id}
                                                             </div>
                                                             <div style="font-size: 11px; color: #aaa; margin-top: 4px;">
                                                                 Click to load form data and view responses
                                                             </div>
                                                         `;
                                                         
                                                         e.target.appendChild(tooltip);
                                                     }}
                                                     onMouseLeave={(e) => {
                                                         const tooltip = document.getElementById('tooltip-' + i + '-' + j);
                                                         if (tooltip) {
                                                             tooltip.remove();
                                                         }
                                                     }}
                                        >
                                       <span
                                           className={j === this.state.current_menu_j && i === this.state.current_menu ?
                                               'sub-menu-link sub-menu-link-active' : 'sub-menu-link'}
                                           data-hover={f.name}
                                           style={{
                                               color: j === this.state.current_menu_j && i === this.state.current_menu ? '#395d9a' : '#666',
                                               fontWeight: j === this.state.current_menu_j && i === this.state.current_menu ? 500 : 400
                                           }}>{f.name}</span>
                                    </div>)
                                })}
                            </div>
                        </div>)
                    })}
                </div>
                    <div className={'col col-sm-9'} style={{padding: 0, overflowX: 'hidden', background: '#f8f9fa'}}>

                        <div style={{padding: '24px 12px 24px 24px', overflowY: 'auto', height: '100%', zIndex: 1}}>

                        {this.props.flag !== 'analyse' ? this.state.forms.map((d, i) => {
                                return (<div key={i} style={{
                                    marginBottom: '24px', 
                                    width: '100%', 
                                    background: 'white',
                                    borderRadius: '0px',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                    overflow: 'hidden',
                                    border: '1px solid #e9ecef',
                                    marginLeft: '0px',
                                    marginRight: '0px',
                                    display: 'block'
                                }}>
                                <div style={{
                                    fontSize: '16px',
                                        color: "#333",
                                        background: '#f8f9fa',
                                        padding: '12px 16px',
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        borderBottom: '1px solid #e9ecef'
                                }}>
                                    <span className={'fa fa-question-circle'}/>{d.name}
                                </div>
                                    <div style={{overflowX: 'auto', margin: '20px'}}>
                                        <table className={'tb'} style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            fontSize: '14px',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            border: '1px solid #e9ecef'
                                        }}>
                                        <thead>
                                        <tr>
                                                <th style={{
                                                    background: '#f8f9fa',
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600,
                                                    color: '#395d9a',
                                                    borderBottom: '2px solid #e9ecef'
                                                }}>#</th>
                                            {d.form_fields.map((q, j) => {
                                                    return (<th style={{
                                                        background: '#f8f9fa',
                                                        padding: '12px 16px',
                                                        textAlign: 'left',
                                                        fontWeight: 600,
                                                        color: '#395d9a',
                                                        borderBottom: '2px solid #e9ecef'
                                                    }} key={j}>{q.form_field}</th>)
                                            })}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {d.answers.map((a, k) => {
                                            return (<tr key={k}>
                                                    <td style={{
                                                        padding: '12px 16px',
                                                        borderBottom: '1px solid #e9ecef',
                                                        verticalAlign: 'top'
                                                    }}>{k + 1}.</td>
                                                {a.row.map((r, l) => {
                                                    return (<td style={{
                                                            padding: '12px 16px',
                                                            borderBottom: '1px solid #e9ecef',
                                                            verticalAlign: 'top', 
                                                            width: l === 0 ? '100px' : 'inherit'
                                                    }} key={l}>{r.answer}</td>)
                                                })}
                                            </tr>)
                                        })}
                                        </tbody>
                                    </table>
                                        <div style={{
                                            padding: '16px 20px',
                                            background: '#f8f9fa',
                                            borderTop: '1px solid #e9ecef',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            flexWrap: 'wrap'
                                        }}>
                                        {d.name === 'Matumizi ya Ardhi' ?
                                            <select name={'village'}
                                                        style={{
                                                            padding: '8px 12px',
                                                            border: '1px solid #e9ecef',
                                                            borderRadius: '6px',
                                                            fontSize: '14px'
                                                        }}
                                                    onChange={this.handleChanges}>
                                                <option value={undefined}>- Choose Village -</option>
                                                {this.state.villages.map((d, i) => {
                                                    return (<option value={d.id} key={i}>{d.name}</option>)
                                                })}
                                            </select> :
                                            <div></div>
                                        }

                                        <button className={'btn error'}
                                                    onClick={() => this.exportData(d.name)}
                                                    style={{
                                                        padding: '8px 16px',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        background: '#f44336',
                                                        color: 'white',
                                                        fontSize: '14px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px'
                                                    }}>
                                                <span className={'fa fa-download'}/>Export
                                        </button>
                                    </div>
                                </div>
                            </div>)
                        }) : this.state.analysis.map((d, i) => {
                            return (<div className={'ucard'} key={i}
                                             style={{
                                                 marginBottom: '24px', 
                                                 width: '100%', 
                                                 background: 'white',
                                                 borderRadius: '0px',
                                                 boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                                 overflow: 'hidden',
                                                 border: '1px solid #e9ecef',
                                                 marginLeft: '0px',
                                                 marginRight: '0px',
                                                 display: 'block'
                                             }}>

                                    <div style={{
                                        background: '#f8f9fa',
                                        color: '#333',
                                        padding: '12px 16px',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        borderBottom: '1px solid #e9ecef'
                                    }}>
                                        <span className="fa fa-chart-bar"/>
                                        {d.name}
                                    </div>

                                <div className={'row'}>
                                        <div className={'col col-sm-10'} style={{borderRight: '1px dashed #888', padding: '20px'}}>
                                        <div id={'bar_' + d.id + '_' + i}>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={this.loadBarChart(d)}
                                            />
                                        </div>

                                        <div id={'pie_' + d.id + '_' + i} style={{display: 'none'}}>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={this.loadPieChart(d)}
                                            />
                                        </div>
                                        <div id={'table_' + d.id + '_' + i} style={{display: 'none'}}>
                                                <div style={{
                                                    fontWeight: 'bold', 
                                                    fontSize: '20px', 
                                                    marginBottom: '16px',
                                                    color: '#395d9a'
                                                }}>
                                                {d.name}
                                            </div>
                                                <div style={{
                                                    overflowX: 'auto',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e9ecef'
                                                }}>
                                                    <table className={'tb'} style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                        fontSize: '14px'
                                                    }}>
                                                <thead>
                                                <tr>
                                                            <th style={{
                                                                background: '#f8f9fa',
                                                                padding: '12px 16px',
                                                                textAlign: 'left',
                                                                fontWeight: 600,
                                                                color: '#395d9a',
                                                                borderBottom: '2px solid #e9ecef'
                                                            }}>DataSet</th>
                                                    {d.categories.map((c, k) => {
                                                                return (<th style={{
                                                                    background: '#f8f9fa',
                                                                    padding: '12px 16px',
                                                                    textAlign: 'left',
                                                                    fontWeight: 600,
                                                                    color: '#395d9a',
                                                                    borderBottom: '2px solid #e9ecef'
                                                                }} key={k}>{c}</th>)
                                                    })}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {d.series.map((s, l) => {
                                                    return (<tr key={l}>
                                                                <td style={{
                                                                    padding: '12px 16px',
                                                                    borderBottom: '1px solid #e9ecef',
                                                                    verticalAlign: 'top'
                                                                }}>{s.name}</td>
                                                        {s.data.map((c, m) => {
                                                                    return (<td style={{
                                                                        padding: '12px 16px',
                                                                        borderBottom: '1px solid #e9ecef',
                                                                        verticalAlign: 'top'
                                                                    }} key={m}>{c}</td>)
                                                        })}
                                                    </tr>)
                                                })}
                                                </tbody>
                                            </table>
                                                </div>
                                        </div>

                                            <div style={{
                                                padding: '16px 20px',
                                                background: '#f8f9fa',
                                                borderTop: '1px solid #e9ecef',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px'
                                            }}>
                                                <button className={'btn submit'} style={{
                                                    padding: '8px 16px',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    background: '#8bc34a',
                                                    color: 'white',
                                                    fontSize: '14px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }}>
                                                    <span className={'fa fa-download'}/>Export
                                            </button>
                                        </div>
                                    </div>

                                    <div className={'col col-sm-2'}
                                             style={{
                                                 height: '100%', 
                                                 position: "sticky", 
                                                 top: 0,
                                                 padding: '16px',
                                                 display: 'flex',
                                                 flexDirection: 'column',
                                                 gap: '8px'
                                             }}>

                                        {this.state.dataview.map((v, j) => {
                                            let id = 'btn_' + i + '_' + j
                                            return (<div onClick={() => this.changeViewAt(d, v, i, j)}
                                                             style={{
                                                                 fontWeight: 'bold',
                                                                 padding: '8px 12px',
                                                                 borderRadius: '6px',
                                                                 fontSize: '12px',
                                                                 cursor: 'pointer',
                                                                 background: j === 0 ? '#395d9a' : '#f8f9fa',
                                                                 color: j === 0 ? 'white' : '#666',
                                                                 display: 'flex',
                                                                 alignItems: 'center',
                                                                 gap: '8px'
                                                             }} key={j} id={id}
                                                         className={j === 0 ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}>
                                                <span className={'fa fa-angle-double-left'}/>{v.name}
                                            </div>)
                                        })}
                                    </div>

                                </div>
                            </div>)
                        })}

                    </div>

                </div>
            </div>

        </div>)
    }

    changeViewAt(d, v, i, j) {
        this.state.analysis.map((dd, ii) => {
            this.state.dataview.map((ss, jj) => {
                document.getElementById('btn_' + ii + '_' + jj).style.background = lightGray
                document.getElementById('btn_' + ii + '_' + jj).style.color = '#666'
            })
        })
        document.getElementById('btn_' + i + '_' + j).style.background = primaryColor
        document.getElementById('btn_' + i + '_' + j).style.color = 'white'

        switch (v.key) {
            case "pie":
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('table_' + d.id + '_' + i).style.display = 'none'
                break
            case "bar":
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('table_' + d.id + '_' + i).style.display = 'none'
                break
            case "table":
                document.getElementById('table_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'none'
                break
        }
    }

    loadPieChart(d) {
        return {
            chart: {
                renderTo: 'high-chart-donut0',
                type: 'pie',
                backgroundColor: 'transparent'
            },
            title: {
                text: d.name,
                style: {
                    color: primaryColor,
                    fontSize: '18px',
                    fontWeight: '600'
                }
            },
            yAxis: {
                title: {
                    text: 'Total percent market share'
                }
            },
            plotOptions: {
                pie: {
                    shadow: true,
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
                }
            },
            series: [{
                name: 'LandUse',
                data: d.data,
                size: '100%',
                innerSize: '10%',
                showInLegend: true,
                dataLabels: {
                    enabled: true
                }
            }]
        }
    }

    loadBarChart(d) {
        return {
            chart: {
                type: 'column',
                backgroundColor: 'transparent'
            },
            title: {
                text: d.name,
                style: {
                    color: primaryColor,
                    fontSize: '18px',
                    fontWeight: '600'
                }
            },
            subtitle: {
                text: ''
            },
            yAxis: {
                title: {
                    text: 'No. of Data',
                    style: {
                        color: primaryColor
                }
            },
                gridLineColor: borderColor
            },
            xAxis: {
                categories: d.categories,
                crosshair: true,
                labels: {
                    style: {
                        color: primaryColor
                    }
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                itemStyle: {
                    color: primaryColor
                }
            },
            series: d.series,
            colors: [primaryColor, secondaryColor, accentColor, successColor, dangerColor],
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        }
    }

    loadData(stage = this.props.stage) {
        /*try {
            Wait.show('Fetching Draft Data....')
            ReadService.fetchCCRDraftData(this.props.project.id,this.state.village_id,this.props.flag).then(r=>{
                Wait.dismiss()
                try{
                    console.log(r.data)
                    this.setState({
                        questions:r.data.questions,
                        answers:r.data.answers
                    })
                }catch (e) {
                    console.log(e)
                }

            })
        }catch (e) {

        }*/
    }

    loadLocalities() {
        /* try{
             Wait.show('Loading Villages...')
             ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                 try {
                     let data = r.data.results

                     console.log(data)
                     this.setState({
                         villages:data,
                         village_id:data[0].id
                     })

                     setTimeout(()=>this.loadData(),500)
                 }catch (e) {
                     console.log(e)
                 }


             })
         }catch (e) {
             console.log(e)
         }*/

    }


    exportData(name) {
        try {
            let village_id = parseInt(this.state.village)

            if (village_id === undefined) {
                alert('Please select a village first')
                return
            }
            
            if (name === 'Matumizi ya Ardhi'){
                try {
                    // Show the download progress modal
                    try {
                        if (window.DownloadProgressModal && typeof window.DownloadProgressModal.show === 'function') {
                            window.DownloadProgressModal.show('Tafadhali kuwa Mvumilivu. Panaweza kuchukua muda mrefu kiasi. kutokana na uwingi wa taarifa...')
                        } else {
                            console.warn('DownloadProgressModal not available, using Wait.show');
                            Wait.show('Tafadhali kuwa Mvumilivu. Panaweza kuchukua muda mrefu kiasi. kutokana na uwingi wa taarifa...')
                        }
                    } catch (error) {
                        console.error('Error showing download modal:', error);
                        Wait.show('Tafadhali kuwa Mvumilivu. Panaweza kuchukua muda mrefu kiasi. kutokana na uwingi wa taarifa...')
                    }
                    
                    CreateService.questionnaireDownloadSHP({
                        project_id: this.props.project.id,
                        village_id: village_id
                    }).then(r => {

                        let pollCount = 0;
                        const maxPolls = 300; // 10 minutes max (300 * 2 seconds)
                        
                        let refreshIntervalId = setInterval(() => {
                            pollCount++;
                            
                            // Check for timeout
                            if (pollCount > maxPolls) {
                                clearInterval(refreshIntervalId);
                                if (window.DownloadProgressModal) {
                                    window.DownloadProgressModal.update(0, 'Error', 'Download timeout. Please try again.')
                                    setTimeout(() => {
                                        window.DownloadProgressModal.dismiss()
                                    }, 3000)
                                } else {
                                    Wait.dismiss()
                                }
                                return;
                            }
                            
                            CreateService.askQuestionnaireDownloadSHPStatus(r.data.task_id).then(d => {
                                let data = d.data
                                let progression = data.progression || 0
                                let state = data.state || 'Processing'

                                console.log('Questionnaire download progress:', progression, 'State:', state, 'Poll count:', pollCount);

                                // Update the modal with progress
                                if (window.DownloadProgressModal) {
                                    window.DownloadProgressModal.update(progression, state, `Tafadhali Subiri....${progression}% => ${state}`)
                                }

                                // Check for completion (progress > 96%)
                                if (progression > 96.0) {
                                    clearInterval(refreshIntervalId)
                                    if (window.DownloadProgressModal) {
                                        window.DownloadProgressModal.update(100, 'Completed', 'Inamalizia....100%')
                                        
                                        setTimeout(() => {
                                            window.DownloadProgressModal.dismiss()
                                            window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                        }, 2000)
                                    } else {
                                        Wait.dismiss()
                                        window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                    }
                                    return;
                                }

                                // Check for failure states
                                if (state === 'FAILURE' || state === 'REVOKED' || state === 'REJECTED') {
                                    clearInterval(refreshIntervalId)
                                    if (window.DownloadProgressModal) {
                                        window.DownloadProgressModal.update(0, 'Error', 'Download failed. Please try again.')
                                        setTimeout(() => {
                                            window.DownloadProgressModal.dismiss()
                                        }, 3000)
                                    } else {
                                        Wait.dismiss()
                                    }
                                    return;
                                }

                                // Check for completion state
                                if (state === 'SUCCESS' && progression >= 100) {
                                    clearInterval(refreshIntervalId)
                                    if (window.DownloadProgressModal) {
                                        window.DownloadProgressModal.update(100, 'Completed', 'Download completed successfully!')
                                        
                                        setTimeout(() => {
                                            window.DownloadProgressModal.dismiss()
                                            window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                        }, 2000)
                                    } else {
                                        Wait.dismiss()
                                        window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                    }
                                    return;
                                }

                                // Continue polling if still processing
                                if (state === 'PENDING' || state === 'STARTED' || state === 'PROGRESS') {
                                    // Continue polling
                                    return;
                                }

                            }).catch(error => {
                                console.error('Error checking questionnaire download status:', error);
                                clearInterval(refreshIntervalId)
                                if (window.DownloadProgressModal) {
                                    window.DownloadProgressModal.update(0, 'Error', 'Download failed. Please try again.')
                                    setTimeout(() => {
                                        window.DownloadProgressModal.dismiss()
                                    }, 3000)
                                } else {
                                    Wait.dismiss()
                                }
                            })
                        }, 2000)

                        // Store the interval ID for cleanup (not needed with simple modal)

                    }).catch(error => {
                        if (window.DownloadProgressModal) {
                            window.DownloadProgressModal.update(0, 'Error', 'Failed to start download. Please try again.')
                            setTimeout(() => {
                                window.DownloadProgressModal.dismiss()
                            }, 3000)
                        } else {
                            Wait.dismiss()
                        }
                    })
                } catch (e) {
                    console.log(e)
                    if (window.DownloadProgressModal) {
                        window.DownloadProgressModal.update(0, 'Error', 'An error occurred. Please try again.')
                        setTimeout(() => {
                            window.DownloadProgressModal.dismiss()
                        }, 3000)
                    } else {
                        Wait.dismiss()
                    }
                }
            }
        } catch (e) {
            console.log(e)
            if (window.DownloadProgressModal) {
                window.DownloadProgressModal.update(0, 'Error', 'An error occurred. Please try again.')
                setTimeout(() => {
                    window.DownloadProgressModal.dismiss()
                }, 3000)
            } else {
                Wait.dismiss()
            }
        }
    }

    toggleMenu(menuId) {
        this.setState((prevState) => ({
            expandedMenus: {
                ...prevState.expandedMenus,
                [menuId]: !prevState.expandedMenus[menuId]
            }
        }));
    }
}
